var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.266,
    height: 12.266,
    viewBox: "0 0 15.266 15.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download_FILL0_wght300_GRAD0_opsz24",
    d: "M187.634-768.511l-4.345-4.345,1.073-1.1,2.509,2.509V-780H188.4v8.549l2.509-2.509,1.073,1.1Zm-5.793,3.777a1.776,1.776,0,0,1-1.305-.534,1.776,1.776,0,0,1-.534-1.305v-2.76h1.527v2.76a.3.3,0,0,0,.1.215.3.3,0,0,0,.215.1h11.586a.3.3,0,0,0,.215-.1.3.3,0,0,0,.1-.215v-2.76h1.527v2.76a1.776,1.776,0,0,1-.534,1.305,1.776,1.776,0,0,1-1.305.534Z",
    transform: "translate(-180.001 779.999)",
    fill: "#1447b2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.cc69451e2a075922814df9d54bf7f78b.svg";
export { ForwardRef as ReactComponent };